<script setup>
const groupedPermissions = Array.from({length: 3}).map((_, i) => ({
  categoryTitle: '',
  permissions: Array.from({length: 4}).map((_, j) => ({
    title: '',
    permission: '',
    description: '',
  }))
}))

</script>

<template>
  <form class="space-y-5">
    <div class="grid grid-cols-2 bg-slate-800 rounded-md text-slate-300 p-4">
      <p>Username: -</p>
      <p>Last Update: -</p>
    </div>

    <div v-for="group in groupedPermissions"
         class="flex flex-col gap-4 pb-6 border-b border-gray-800 last:border-0">
      <p>{{ group.categoryTitle }}</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div v-for="permission in group.permissions" class="flex flex-col animate-pulse">
          <div class="flex flex-row">
            <div
                class="flex justify-center items-center rounded-tr-md px-3 font-semibold border-[#e0e6ed] dark:border-[#17263c]"
            >
              <div class="size-5 rounded-[4px] border border-[#e0e6ed] dark:border-white-dark"></div>
            </div>
            <p class="form-input border-b-0 border-[#17263c] rounded-t-md bg-[#121e32] w-96 h-10"></p>
          </div>
          <div class="p-3 form-input border-t-0 border-[#17263c] rounded-b-md rounded-tl-md bg-[#121e32] h-10"></div>
        </div>
      </div>
    </div>
  </form>
</template>

<style scoped lang="scss">

</style>